/**
 * @file truncateText.js
 * @brief Provides responsive truncation helpers for listing titles and other compact labels.
 */
export const LISTING_TITLE_DISPLAY_MAX = 55;
export const LISTING_TITLE_DISPLAY_MAX_MOBILE = 28;

/**
 * Pick the default title truncation length based on the current viewport width.
 * @returns {number} Title character limit suitable for the active screen size.
 */
function getResponsiveTitleLimit() {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
        return LISTING_TITLE_DISPLAY_MAX;
    }

    return window.matchMedia("(max-width: 768px)").matches
        ? LISTING_TITLE_DISPLAY_MAX_MOBILE
        : LISTING_TITLE_DISPLAY_MAX;
}

export function truncateText(value, maxLength = getResponsiveTitleLimit()) {
    const text = String(value ?? "");
    if (text.length <= maxLength) return text;
    return `${text.slice(0, Math.max(0, maxLength - 1)).trimEnd()}…`;
}
